// we use the same CSS style as the buttons, and then some additional css to smooth out the differences
import './btn_basic.less';

import React from 'react';

import { Buttonizer } from './btn_basic.jsx';

const ButtonLink = (props)=>
  <Buttonizer Tag="a" {...props} />;

export default ButtonLink;